<template>
  <b-overlay
      :show="show"
      spinner-variant="primary"
      spinner-type="grow"
      spinner-small
      rounded="sm"
    >
      <b-card title="">
      <!-- <b-card-text>service.</b-card-text> -->
      <validation-observer ref="simpleRules">
        <b-form @submit.prevent>
          <b-row>
            <!-- Legal Service -->
            <b-col cols="12">
              <b-form-group label="Legal Service" label-for="v-legal-service">
                <validation-provider #default="{ errors }"  name="Legal Service" rules="required">
                  <b-form-input  id="v-legal-service-name" :state="errors.length > 0 ? false:null" v-model="form.text_1" autocomplete="off" placeholder="Legal Service" />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>
            <!-- Icon -->
            <b-col cols="12">
              <b-form-group label="Icon" label-for="v-icon">
                <validation-provider #default="{ errors }" name="Icon" >
                  <b-form-input id="v-icon" :state="errors.length > 0 ? false:null" v-model="form.text_2" autocomplete="off" placeholder="Icon" />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>
            <!-- Desc -->
            <b-col cols="12">
              <b-form-group label="Desc" label-for="v-desc">
                <validation-provider #default="{ errors }" name="Desc" >
                  <b-form-input id="v-desc" :state="errors.length > 0 ? false:null" v-model="form.text_3" autocomplete="off" placeholder="Desc" />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>
            <!-- isHighlight -->
            <b-col cols="1">
              <b-form-group label="isHighlight" label-for="v-isHighlight">
                <b-form-checkbox
                  checked="true"
                  class="custom-control-primary"
                  name="check-button"
                  v-model="form.checkbox_4"
                  switch
                >
                  <span class="switch-icon-left">
                    <feather-icon icon="MaximizeIcon" />
                  </span>
                  <span class="switch-icon-right">
                    <feather-icon icon="MaximizeIcon" />
                  </span>
                </b-form-checkbox>
              </b-form-group>
            </b-col>
            <!-- Type -->
            <b-col cols="12">
              <b-form-group label="Type" label-for="v-type">
                <validation-provider #default="{ errors }" name="Type" >
                  <v-select
                    v-model="form.select_5"
                    placeholder="Chose Type" autocomplete="off" 
                    :state="errors.length > 0 ? false:null"
                    :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                    label="title"
                    :reduce="option_1 => option_1.value"
                    :options="option_1"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>
            <!-- Duration -->
            <b-form-group class="ml-1" label="Duration" label-for="v-duration">
              <b-input-group>
                <validation-provider #default="{ errors }" name="Duration" >
                  <b-form-input id="v-duration" :state="errors.length > 0 ? false:null" autocomplete="off" v-model="form.text_6" placeholder="Duration" />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
                <b-input-group-append>
                  <validation-provider #default="{ errors }" name="Duration Unit" >
                    <v-select
                      v-model="form.select_7"
                      placeholder="Chose Unit Duration" autocomplete="off" 
                      :state="errors.length > 0 ? false:null"
                      :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                      :reduce="option_2 => option_2.value"
                      label="title"
                      :options="option_2"
                    />
                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </b-input-group-append>
              </b-input-group>
            </b-form-group>
            <!-- submit and reset -->
            <b-col cols="12"><div class="h-50 d-inline-block"></div></b-col>
            <b-col cols="12">
              <b-button v-ripple.400="'rgba(255, 255, 255, 0.15)'" type="submit" variant="primary" class="mr-1" @click.prevent="validationForm"> Submit </b-button>
              <b-button v-ripple.400="'rgba(186, 191, 199, 0.15)'" type="reset" variant="outline-secondary"> Reset </b-button>
            </b-col>
          </b-row>
        </b-form>
      </validation-observer>
    </b-card>
  </b-overlay>
</template>
<script>
import { ValidationProvider, ValidationObserver } from 'vee-validate'
import { BRow, BOverlay, BCol, BFormGroup, BFormInput, BInputGroup, BInputGroupAppend, BFormCheckbox, BFormFile, BForm, BButton, BCard, BCardText, BMedia, BMediaAside, BMediaBody, BLink, BImg } from 'bootstrap-vue'
import { required } from '@validations'
import Ripple from 'vue-ripple-directive'
import vSelect from 'vue-select'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
export default {
  components: { vSelect, BOverlay, ValidationProvider, ValidationObserver, BInputGroup, BInputGroupAppend, BFormCheckbox, BCard, BCardText, BRow, BCol, BFormGroup, BFormInput, BFormFile, BForm, BButton, BMedia, BMediaAside, BMediaBody, BLink, BImg },
  directives: { Ripple },
  data () {
    return { 
      option_1: [{ value: 'OC', title: 'Chat' }, { value: 'OV', title: 'Video' }, { value: 'LS', title: 'Legal Service' }],
      option_2: [{ value: 'Second', title: 'Second' }, { value: 'Minute',title: 'Minute' }, { value: 'Hour', title: 'Hour' }, { value: 'Day', title: 'Day' }],
      form: {id: null, text_1: '',text_2: '',text_3: '',checkbox_4: false,select_5: {value: 'OC'},text_6: '',select_7: {value:'Minute'}},
      show: false,
      required 
    }
  },
  methods: {
    validationForm () {
      this.show = true
      this.$refs.simpleRules.validate()
      .then(success => {
        if (success) {
          const formData = this.form 
			    this.$store.dispatch('service/formPostPut', formData)
          .then(res => {
            this.notification('Success','CheckIcon','success','You have successfully')
          }, 
          err => {
            this.show = false
            this.notification('Failed','CloseIcon','danger','You have unsuccessful')
          })
        } else {
          this.show = false
          this.notification('Failed','CloseIcon','danger','You have unsuccessful')
        }
      })
    },
    notification (a,b,c,d) {
      this.$toast({
        component: ToastificationContent,
        position: 'top-right',
        props: { title: a, icon: b, variant: c, text: d}
      })
    },
    getData (id) {
			this.$store.dispatch('service/getById', id).then(data => {
        this.form.id = data.id
        this.form.text_1 = data.name
        this.form.text_2 = data.icon
        this.form.text_3 = data.desc
        this.form.checkbox_4 = data.is_highlight === true ? true : false,
        this.form.select_5 = data.type
        this.form.text_6 = data.duration
        this.form.select_7 = data.duration_unit
        this.show = false
      })
    }
  },
  mounted () {
    if (this.$route.params.id) {
      this.show = true
      this.getData(this.$route.params.id)
    }
  }
}
</script>

<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';
</style>